<template>
    <div class="container mt-5">
        <h1>Contact Us</h1>
        <h3>Please fill in the following form to contact us</h3>
        <p class="alert-danger">
            Budapest-Escort-Girl.EU is an advertising site only. Please be aware that we cannot help you with booking
            requests. If you'd like to book one of our advertisers, feel free to text her.
            <br/>
            Also please note, that for the same reason mentioned above, we are unable to give you information regarding
            our advertisers' prices and services.
            Thank you.
        </p>

        <div class="row justify-content-center">
            <div class="col-md-6 sm-12">
                <vue-form :state="formstate" @submit.prevent="sendMessage">

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                        <label>Your name</label>
                        <input type="text" name="name" class="form-control" required v-model.lazy="model.name">

                        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Name is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)">
                        <label>Email address</label>
                        <input type="email" name="email" class="form-control" required v-model.lazy="model.email">

                        <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Email address is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.message)">
                        <label>Message</label>
                        <textarea rows="8" name="message" class="form-control" required v-model.lazy="model.message"></textarea>

                        <field-messages name="message" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Message is required!</div>
                        </field-messages>
                    </validate>

                    <button class="btn btn-dark" type="submit">Send message</button>
                </vue-form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Contact",
        metaInfo: {
            title: 'Contacts'
        },
        data() {
            return {
                formstate: {},
                model: {
                    name: '',
                    email: '',
                    message: '',
                }
            }
        },
        methods: {
            sendMessage: function() {
                this.$http.post(`${process.env.VUE_APP_API_URL}/contacts`, this.model)
                    .then(() => {
                        this.$bvModal.msgBoxOk('Your message has been sent!');
                        this.model.name = '';
                        this.model.email = '';
                        this.model.message = '';
                    }).catch(() => {
                    this.$bvModal.msgBoxOk('Error sending email!')
                })
            },
            fieldClassName: function (field) {
                if(!field) {
                    return '';
                }
                if((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success';
                }
                if((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger';
                }
            },
        }

    }
</script>

<style scoped>

</style>
